import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export interface userUpdateDataResponse {
  _id: string;
  name: string;
  email: string;
  phone: string;
  birthDate: string;
  commission?: number;
  address: {
    zipCode: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: string;
  };
  bankAccount: {
    bank: string;
    agency: string;
    account: string;
    accountType: string;
    pixKey: string;
    pixType: string;
  };
}

export interface userUpdateData {
  _id?: string;
  name?: string;
  email?: string;
  phone?: string;
  birthDate?: string;
  commission?: number;
  commissions?: Record<PartnerType, number>;
  commissionsV2?: Record<PartnerType, PartnerCommissionConfig>;
  address?: {
    zipCode?: string;
    state?: string;
    city?: string;
    neighborhood?: string;
    street?: string;
    number?: string;
  };
  bankAccount?: {
    bank?: string;
    agency?: string;
    account?: string;
    accountType?: string;
    pixKey?: string;
    pixType?: string;
  };
}

export interface CommissionItem {
  _id?: string;
  value?: number;
  supervisorCommission?: number;
}

export interface PartnerCommissionConfig {
  _id?: string;
  items: CommissionItem[];
}

export async function userUpdate(updateData: userUpdateData, id: string) {
  const { data } = await httpClient.put<userUpdateDataResponse>(
    `/user/${id}`,
    updateData,
    {
      headers: {
        "x-mock-response-name": "Update User",
      },
    },
  );

  return data;
}
